module.exports = __webpack_public_path__ + "img/button.4b32a1ec.png";